import React from "react";
export default function SVGProcedure1() {
  return (
    <svg version="1.1" viewBox="0 0 64 64">
      <g fill="#000000">
        <path
          fill="#000000"
          d="M50,38c-6.627,0-12,5.373-12,12c0,6.627,5.373,12,12,12s12-5.373,12-12C62,43.373,56.627,38,50,38z M43,52  c-1.105,0-2-0.895-2-2c0-1.105,0.895-2,2-2s2,0.895,2,2C45,51.105,44.105,52,43,52z M50,52c-1.105,0-2-0.895-2-2  c0-1.105,0.895-2,2-2s2,0.895,2,2C52,51.105,51.105,52,50,52z M57,52c-1.105,0-2-0.895-2-2c0-1.105,0.895-2,2-2s2,0.895,2,2  C59,51.105,58.105,52,57,52z"
        />
        <path
          fill="#000000"
          d="M32,26c6.627,0,12-5.373,12-12c0-6.627-5.373-12-12-12S20,7.373,20,14C20,20.627,25.373,26,32,26z M35.5,12  c1.105,0,2,0.895,2,2c0,1.105-0.895,2-2,2s-2-0.895-2-2C33.5,12.895,34.395,12,35.5,12z M28.5,12c1.105,0,2,0.895,2,2  c0,1.105-0.895,2-2,2s-2-0.895-2-2C26.5,12.895,27.395,12,28.5,12z"
        />
        <path
          opacity="0.5"
          fill="#000000"
          d="M14,38C7.373,38,2,43.373,2,50c0,6.627,5.373,12,12,12s12-5.373,12-12C26,43.373,20.627,38,14,38z M14,52  c-1.105,0-2-0.895-2-2c0-1.105,0.895-2,2-2s2,0.895,2,2C16,51.105,15.105,52,14,52z"
        />
        <path
          opacity="0.5"
          fill="#000000"
          d="M17.599,15.8l-1.201-1.6C9.79,19.164,6,26.745,6,35c0,0.348,0.007,0.693,0.021,1.038l1.998-0.076  C8.007,35.643,8,35.322,8,35C8,27.38,11.499,20.382,17.599,15.8z"
        />
        <path
          opacity="0.5"
          fill="#000000"
          d="M26.239,58.305l-0.479,1.941C27.79,60.746,29.889,61,32,61s4.21-0.254,6.239-0.754l-0.479-1.941  C34.015,59.227,29.985,59.227,26.239,58.305z"
        />
        <path
          opacity="0.5"
          fill="#000000"
          d="M57.979,36.038C57.993,35.693,58,35.348,58,35c0-8.255-3.79-15.836-10.397-20.8l-1.201,1.6C52.501,20.382,56,27.38,56,35  c0,0.322-0.007,0.643-0.019,0.962L57.979,36.038z"
        />
      </g>
    </svg>
  );
}
